module.exports = __webpack_public_path__ + "img/Sarah-Richardson.1fade875.png";